import * as Sentry from '@sentry/nextjs'
import { isPrd } from '@shared/util/env'

import { injectOneLinkScriptPrd } from './scripts/onelink-prd'

/**
 * Initialize OneLink Smart Script for step.com (production)
 *
 * The actual script is in ./scripts/onelink-prd.ts for easy updates.
 */
export const initOneLinkSmartScriptPrd = (): void => {
    if (typeof window === 'undefined') {
        return
    }

    // Skip if already initialized
    if (window.AF_SMART_SCRIPT) {
        return
    }

    try {
        injectOneLinkScriptPrd()

        if (!isPrd()) {
            console.debug('OneLink Smart Script (prd) initialized')
        }
    } catch (error) {
        Sentry.captureException(error, {
            tags: {
                errorType: 'onelink_init_failed',
                analytics: 'appsflyer',
                environment: 'prd',
            },
        })
        if (!isPrd()) {
            console.error(
                'Failed to initialize OneLink Smart Script (prd):',
                error,
            )
        }
    }
}
